import { ArrowRight, Loader2 } from "lucide-react";
import React from "react";

// Add this Demo Modal Component before the main return statement
export const DemoStripeModal = ({ isOpen, onClose, onConnect }: { isOpen: boolean; onClose: () => void; onConnect: () => void }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4">
                {/* Header */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                            <span className="text-purple-600 font-bold text-lg">TS</span>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-900">ThriveStack Corporation</h2>
                    </div>
                </div>

                {/* Body */}
                <div className="p-6">
                    <h3 className="text-2xl font-bold text-gray-900 mb-4">
                        ThriveStack Corporation partners with Stripe for secure payments.
                    </h3>

                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                        <p className="text-sm text-blue-800">
                            ℹ️ You're using a test account with test data.
                        </p>
                    </div>

                    <h4 className="text-xl font-semibold text-gray-900 mb-4">
                        Get started with Stripe
                    </h4>
                    <p className="text-gray-600 mb-6">
                        If you're completing this form on behalf of a business, it must be completed by the business owner or someone with significant management responsibility of that business.
                    </p>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConnect}
                        className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-2"
                    >
                        <span>Connect Account</span>
                        <ArrowRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};